import AbstractStrategy from './abstract';

class FileStrategy extends AbstractStrategy {
  constructor({traps}) {
    super(...arguments);
    this.promises = traps.map((url) => window.__VOONTO__.load(url));
  }
}

export default FileStrategy;



// WEBPACK FOOTER //
// ./src/strategies/file.js